var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCubeLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 519.45 619.65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "43.36 438.98 43.36 438.98 43.36 438.98 43.36 438.98",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "43.36 387.36 43.36 387.36 43.36 387.36 43.36 387.36",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "43.36 335.75 43.36 335.75 43.36 335.75 43.36 335.75",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "43.36 284.13 43.36 284.13 43.36 284.13 43.36 284.13",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "43.36 284.13 .1 258.34 .1 309.96 43.36 284.13 43.36 284.13",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "43.36 387.36 .1 361.57 .1 413.19 43.36 387.36 43.36 387.36",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "43.36 335.75 .1 309.96 .1 361.57 43.36 335.75 43.36 335.75",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "43.36 180.9 .1 155.11 .1 206.73 43.36 180.9 43.36 180.9",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "43.36 180.9 43.36 180.9 43.36 180.9 43.36 180.9",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "43.36 232.52 .1 206.73 .1 258.34 43.36 232.52 43.36 232.52",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "43.36 232.52 43.36 232.52 43.36 232.52 43.36 232.52",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "86.63 103.4 86.63 103.47 86.68 103.43 86.63 103.4",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "43.36 438.98 .1 413.19 .1 464.8 43.36 438.98 43.36 438.98",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "519.36 361.57 519.36 309.96 476.08 335.75 519.36 361.57",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "519.36 309.96 519.36 258.34 476.08 284.13 519.36 309.96",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "519.36 464.8 519.36 413.19 476.08 438.98 519.36 464.8",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "519.36 258.34 519.36 206.73 476.08 232.52 519.36 258.34",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "519.36 413.19 519.36 361.57 476.08 387.36 519.36 413.19",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "476.08 180.9 519.36 206.73 519.36 155.11 476.08 180.9",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "129.86 129.18 129.86 129.28 129.94 129.23 129.86 129.18",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "216.42 26 259.69 51.78 259.69 .17 173.16 51.82 216.42 77.61 216.42 26",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "302.85 25.92 259.69 .17 259.69 51.78 302.85 25.92",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "302.87 77.55 302.85 25.92 302.85 25.92 259.69 51.78 302.87 77.55",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "432.72 155.03 475.95 180.83 475.93 129.2 475.93 129.2 432.72 154.99 432.72 155.03",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "302.94 77.59 346.18 51.8 346.22 103.41 346.25 103.43 389.53 77.64 389.54 129.15 432.69 103.4 432.72 154.99 475.93 129.2 302.85 25.92 302.87 77.55 302.94 77.59",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "86.63 154.97 86.63 155.08 86.72 155.03 86.63 154.97",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "389.54 129.26 389.54 129.15 389.44 129.2 389.54 129.26",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "432.68 155.01 432.72 154.99 432.69 103.4 389.54 129.15 389.54 129.26 432.68 155.01",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "432.72 155.03 432.72 154.99 432.68 155.01 432.72 155.03",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "389.54 129.15 389.53 77.64 346.25 103.43 389.44 129.2 389.54 129.15",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "346.18 51.8 302.94 77.59 346.22 103.41 346.18 51.8",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "259.69 51.78 216.42 26 216.42 77.61 216.42 77.61 259.69 51.78",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "476.08 180.9 519.36 155.11 475.93 129.2 475.95 180.83 476.08 180.9",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "86.63 103.47 43.47 129.22 86.63 154.97 86.63 103.47",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "43.36 180.9 86.63 155.08 86.63 154.97 43.47 129.22 43.36 129.29 43.36 180.9 43.36 180.9",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "216.42 77.61 216.42 77.61 173.16 51.82 173.16 51.82 173.16 103.43 216.42 77.61",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "43.36 129.29 .1 155.11 43.36 180.9 43.36 129.29",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "86.72 155.03 129.86 129.28 129.86 129.18 86.68 103.43 86.63 103.47 86.63 154.97 86.72 155.03",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "173.16 103.43 173.16 51.82 129.86 77.66 173.14 103.44 173.16 103.43",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "129.94 129.23 173.14 103.44 129.86 77.66 129.86 77.66 129.86 129.18 129.94 129.23",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "129.86 77.66 86.68 103.43 129.86 129.18 129.86 77.66",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "86.63 206.7 86.63 206.69 43.36 180.9 43.36 180.9 43.36 232.52 43.36 232.52 86.63 206.7",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "475.95 180.98 475.98 232.46 476.08 232.52 519.36 206.73 476.08 180.9 475.95 180.98",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "475.98 232.46 475.95 180.98 432.8 206.69 475.98 232.46",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "43.36 180.9 .1 206.73 43.36 232.52 43.36 180.9",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "86.63 206.69 86.63 206.7 86.63 206.69 86.63 206.69",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "129.96 180.83 173.16 155.05 173.16 155.01 129.94 129.23 129.86 129.28 129.86 180.77 129.96 180.83",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "173.16 103.43 173.14 103.44 173.16 103.46 173.16 103.43",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "475.95 180.98 476.08 180.9 475.95 180.83 475.95 180.98",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "173.16 103.46 173.14 103.44 129.94 129.23 173.16 155.01 173.16 103.46",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "173.16 155.01 173.16 155.05 173.19 155.03 173.16 155.01",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "129.86 129.28 86.72 155.03 129.86 180.77 129.86 129.28",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "86.63 155.08 43.36 180.9 86.63 206.69 86.63 155.08",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "86.63 206.69 129.86 180.89 129.86 180.77 86.72 155.03 86.63 155.08 86.63 206.69 86.63 206.69",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "389.54 180.88 389.54 180.75 389.43 180.81 389.54 180.88",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "432.68 155.01 389.54 129.26 389.54 180.75 432.68 155.01",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "389.43 180.81 389.54 180.75 389.54 129.26 389.44 129.2 346.26 154.97 346.26 155.05 389.43 180.81",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "216.41 129.23 173.16 103.46 173.16 155.01 173.19 155.03 216.41 129.23",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "389.54 180.75 389.54 180.88 432.75 206.66 432.72 155.03 432.68 155.01 389.54 180.75",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "346.26 155.05 346.26 154.97 346.19 155.01 346.26 155.05",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "346.26 154.97 346.22 103.45 302.97 129.22 346.19 155.01 346.26 154.97",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "346.26 154.97 389.44 129.2 346.25 103.43 346.22 103.45 346.26 154.97",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "302.94 77.59 302.87 77.55 302.87 77.63 302.94 77.59",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "302.87 77.63 302.87 77.55 259.69 51.78 259.69 103.39 302.87 77.63",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "216.41 129.23 216.42 129.23 216.42 77.61 173.16 103.43 173.16 103.46 216.41 129.23",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "346.25 103.43 346.22 103.41 346.22 103.45 346.25 103.43",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "302.9 129.18 302.97 129.22 346.22 103.45 346.22 103.41 302.94 77.59 302.87 77.63 302.9 129.18",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "259.69 103.4 259.69 103.39 259.51 103.5 259.69 103.39 259.69 51.78 216.42 77.61 259.68 103.4 216.42 77.61 216.42 77.61 216.42 129.23 259.69 103.4",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "302.87 77.63 259.69 103.39 259.69 103.4 302.9 129.18 302.87 77.63",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "129.86 180.77 129.86 180.89 129.96 180.83 129.86 180.77",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "432.72 155.03 432.75 206.66 432.8 206.69 475.95 180.98 475.95 180.83 432.72 155.03",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "86.63 258.31 86.63 258.31 86.63 258.31 86.63 258.31",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "475.98 232.58 476 284.08 476.08 284.13 519.36 258.34 476.08 232.52 475.98 232.58",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "43.36 232.52 .1 258.34 43.36 284.13 43.36 232.52",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "86.63 258.31 86.63 258.31 43.36 232.52 43.36 232.52 43.36 284.13 43.36 284.13 86.63 258.31",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "476 284.08 475.98 232.58 432.8 258.31 476 284.08",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "129.86 232.51 129.86 232.46 86.63 206.69 86.63 206.7 86.63 258.31 86.63 258.31 129.86 232.51",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "476.08 232.52 475.98 232.46 475.98 232.58 476.08 232.52",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "432.75 206.73 432.77 258.29 432.8 258.31 475.98 232.58 475.98 232.46 432.8 206.69 432.75 206.73",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "389.55 232.5 389.55 232.47 389.52 232.48 389.55 232.5",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "389.55 232.5 432.77 258.29 432.75 206.73 389.55 232.47 389.55 232.5",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "129.86 232.46 129.86 232.51 129.89 232.48 129.86 232.46",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "43.36 232.52 86.63 258.31 86.63 206.7 43.36 232.52",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "389.55 232.47 432.75 206.73 432.75 206.66 389.54 180.88 389.55 232.47",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "216.42 180.82 216.42 129.23 216.41 129.23 173.19 155.03 216.42 180.82",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "173.16 206.61 173.16 206.66 173.2 206.63 173.16 206.61",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "216.42 180.82 216.42 180.84 216.44 180.83 216.42 180.82",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "346.3 206.56 346.26 155.05 346.19 155.01 302.94 180.82 346.18 206.62 346.3 206.56",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "346.3 206.69 346.3 206.56 346.18 206.62 346.3 206.69",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "346.3 206.56 346.3 206.69 389.52 232.48 389.55 232.47 389.54 180.88 389.43 180.81 346.3 206.56",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "216.42 129.23 216.41 129.23 216.42 129.23 216.42 129.23",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "173.2 206.63 216.42 180.84 216.42 180.82 173.19 155.03 173.16 155.05 173.16 206.61 173.2 206.63",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "259.68 155.01 259.69 155 259.69 103.4 216.42 129.23 216.42 129.23 259.68 155.01",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "129.86 180.89 86.63 206.69 129.86 232.46 129.86 180.89",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "302.9 129.26 302.9 129.18 259.69 103.4 259.69 155 302.9 129.26",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "259.69 155 259.68 155.01 259.69 155.01 259.69 155",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "302.97 129.22 302.9 129.18 302.9 129.26 302.97 129.22",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "259.69 155.01 259.68 155.01 259.68 155.01 259.68 155.01 216.42 129.23 216.42 180.82 216.44 180.83 259.69 155.01",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "432.8 206.69 432.75 206.66 432.75 206.73 432.8 206.69",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "302.92 180.81 302.9 129.26 259.69 155 259.69 155.01 302.92 180.81",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "129.89 232.48 173.16 206.66 173.16 206.61 129.96 180.83 129.86 180.89 129.86 232.46 129.89 232.48",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "173.16 155.05 129.96 180.83 173.16 206.61 173.16 155.05",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "389.43 180.81 346.26 155.05 346.3 206.56 389.43 180.81",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "302.92 180.81 302.94 180.82 346.19 155.01 302.97 129.22 302.9 129.26 302.92 180.81",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "43.36 284.13 .1 309.96 43.36 335.75 43.36 284.13",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "86.63 309.93 86.63 309.92 43.36 284.13 43.36 284.13 43.36 335.75 43.36 335.75 86.63 309.93",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "86.63 309.92 86.63 309.93 86.63 309.92 86.63 309.92",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "476 284.18 476.02 335.71 476.08 335.75 519.36 309.96 476.08 284.13 476 284.18",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "432.8 309.92 476.02 335.71 476 284.18 432.8 309.92 432.8 309.92",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "432.77 258.32 432.8 309.92 476 284.18 476 284.08 432.8 258.31 432.77 258.32",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "389.56 284.12 389.56 284.08 389.52 284.1 389.56 284.12",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "476.08 284.13 476 284.08 476 284.18 476.08 284.13",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "43.36 284.13 86.63 309.92 86.63 258.31 43.36 284.13",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "129.86 284.12 129.86 284.08 86.63 258.31 86.63 258.31 86.63 309.92 86.63 309.92 129.86 284.12",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "389.56 284.12 432.8 309.92 432.8 309.92 432.77 258.32 389.56 284.08 389.56 284.12",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "129.86 284.08 129.86 284.12 129.89 284.1 129.86 284.08",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "86.63 258.31 129.86 284.08 129.86 232.51 86.63 258.31",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "432.8 258.31 432.77 258.29 432.77 258.32 432.8 258.31",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "346.33 258.33 346.33 258.22 346.25 258.28 346.33 258.33",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "173.16 258.28 173.16 258.27 129.89 232.48 129.86 232.51 129.86 284.08 129.89 284.1 173.16 258.28",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "346.33 258.22 346.33 258.33 389.52 284.1 389.56 284.08 389.55 232.5 389.52 232.48 346.33 258.22",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "389.56 284.08 432.77 258.32 432.77 258.29 389.55 232.5 389.56 284.08",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "173.16 206.66 129.89 232.48 173.16 258.27 173.16 206.66",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "259.69 206.62 302.92 180.82 302.92 180.81 259.69 155.01 259.69 206.62",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "173.16 258.28 216.42 232.45 216.42 232.42 173.2 206.63 173.16 206.66 173.16 258.27 173.16 258.28",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "216.42 180.84 173.2 206.63 216.42 232.42 216.42 180.84",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "302.95 232.42 302.95 232.44 346.25 258.28 346.33 258.22 346.3 206.69 346.18 206.62 302.95 232.42",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "302.94 180.82 302.92 180.81 302.92 180.82 302.94 180.82",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "302.95 232.42 346.18 206.62 302.94 180.82 302.92 180.82 302.95 232.42",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "216.45 232.44 259.69 206.63 259.68 206.62 259.68 206.63 259.68 206.62 216.44 180.83 216.42 180.84 216.42 232.42 216.45 232.44",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "302.95 232.44 302.95 232.42 302.93 232.43 302.95 232.44",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "259.69 155.01 216.44 180.83 259.68 206.62 259.69 206.62 259.69 155.01",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "302.95 232.42 302.92 180.82 259.69 206.62 259.69 206.63 302.93 232.43 302.95 232.42",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "259.68 206.62 259.69 206.63 259.69 206.62 259.68 206.62",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "389.52 232.48 346.3 206.69 346.33 258.22 389.52 232.48",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "216.42 232.42 216.42 232.45 216.45 232.44 216.42 232.42",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "86.63 361.54 86.63 361.54 43.36 335.75 43.36 335.75 43.36 387.36 43.36 387.36 86.63 361.54",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "432.83 361.56 432.83 361.52 432.8 361.54 432.83 361.56",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "86.63 361.54 86.63 361.54 86.63 361.54 86.63 361.54",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "476.02 335.78 476.04 387.34 476.08 387.36 519.36 361.57 476.08 335.75 476.02 335.78",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "43.36 335.75 .1 361.57 43.36 387.36 43.36 335.75",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "432.83 361.56 476.04 387.34 476.02 335.78 432.83 361.52 432.83 361.56",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "129.86 335.69 129.86 335.74 129.89 335.71 129.86 335.69",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "432.83 361.52 476.02 335.78 476.02 335.71 432.8 309.92 432.83 361.52",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "43.36 335.75 86.63 361.54 86.63 309.93 43.36 335.75",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "389.56 335.69 389.56 335.74 432.8 361.54 432.83 361.52 432.8 309.92 432.8 309.92 389.56 335.69",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "389.56 335.74 389.56 335.69 389.52 335.71 389.56 335.74",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "476.08 335.75 476.02 335.71 476.02 335.78 476.08 335.75",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "129.86 335.74 129.86 335.69 86.63 309.92 86.63 309.93 86.63 361.54 86.63 361.54 129.86 335.74",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "346.37 309.82 346.37 309.96 389.52 335.71 389.56 335.69 389.56 284.12 389.52 284.1 346.37 309.82",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "86.63 309.92 129.86 335.69 129.86 284.12 86.63 309.92",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "346.37 309.96 346.37 309.82 346.25 309.89 346.37 309.96",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "173.16 309.89 173.16 309.89 129.89 284.1 129.86 284.12 129.86 335.69 129.89 335.71 173.16 309.89",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "432.8 309.92 389.56 284.12 389.56 335.69 432.8 309.92",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "216.42 284.07 216.42 284.06 173.16 258.28 173.16 258.28 173.16 309.89 173.16 309.89 216.42 284.07",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "216.42 284.06 216.42 284.07 216.43 284.07 216.42 284.06",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "129.89 284.1 173.16 309.89 173.16 258.28 129.89 284.1",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "389.52 284.1 346.33 258.33 346.37 309.82 389.52 284.1",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "302.97 284.06 302.97 284.07 346.25 309.89 346.37 309.82 346.33 258.33 346.25 258.28 302.97 284.06",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "259.69 258.23 259.69 206.63 216.45 232.44 259.68 258.24 259.69 258.23",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "302.93 232.43 259.69 206.63 259.69 258.23 302.93 232.43",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "259.69 258.23 259.69 258.24 302.97 284.07 302.97 284.06 302.95 232.44 302.93 232.43 259.69 258.23",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "216.42 232.45 173.16 258.28 216.42 284.06 216.42 232.45",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "259.68 258.24 259.69 258.24 259.69 258.23 259.68 258.24",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "216.43 284.07 259.69 258.24 259.68 258.24 259.68 258.24 259.68 258.24 216.45 232.44 216.42 232.45 216.42 284.06 216.43 284.07",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "346.25 258.28 302.95 232.44 302.97 284.06 346.25 258.28",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "432.86 413.19 476.06 438.97 476.04 387.39 432.86 413.12 432.86 413.19",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "43.36 387.36 .1 413.19 43.36 438.98 43.36 387.36",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "86.63 413.15 86.63 413.16 86.63 413.15 86.63 413.15",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "476.04 387.39 476.06 438.97 476.08 438.98 519.36 413.19 476.08 387.36 476.04 387.39",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "86.63 413.16 86.63 413.15 43.36 387.36 43.36 387.36 43.36 438.98 43.36 438.98 86.63 413.16",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "432.86 413.19 432.86 413.12 432.8 413.15 432.86 413.19",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "389.57 387.36 389.57 387.3 389.52 387.33 389.57 387.36",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "43.36 387.36 86.63 413.15 86.63 361.54 43.36 387.36",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "476.08 387.36 476.04 387.34 476.04 387.39 476.08 387.36",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "129.86 387.35 129.86 387.31 86.63 361.54 86.63 361.54 86.63 413.15 86.63 413.15 129.86 387.35",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "389.57 387.3 389.57 387.36 432.8 413.15 432.86 413.12 432.83 361.56 432.8 361.54 389.57 387.3",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "129.86 387.31 129.86 387.35 129.89 387.33 129.86 387.31",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "432.86 413.12 476.04 387.39 476.04 387.34 432.83 361.56 432.86 413.12",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "173.16 361.51 173.16 361.5 129.89 335.71 129.86 335.74 129.86 387.31 129.89 387.33 173.16 361.51",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "346.41 361.6 346.41 361.41 346.25 361.51 346.41 361.6",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "432.8 361.54 389.56 335.74 389.57 387.3 432.8 361.54",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "86.63 361.54 129.86 387.31 129.86 335.74 86.63 361.54",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "346.41 361.41 346.41 361.6 389.52 387.33 389.57 387.3 389.56 335.74 389.52 335.71 346.41 361.41",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "303 335.66 303 335.7 346.25 361.51 346.41 361.41 346.37 309.96 346.25 309.89 303 335.66",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "216.42 335.68 216.42 335.68 173.16 309.89 173.16 309.89 173.16 361.5 173.16 361.51 216.42 335.68",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "129.89 335.71 173.16 361.5 173.16 309.89 129.89 335.71",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "303 335.7 303 335.66 302.97 335.68 303 335.7",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "216.42 335.68 216.42 335.68 216.43 335.68 216.42 335.68",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "389.52 335.71 346.37 309.96 346.41 361.41 389.52 335.71",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "346.25 309.89 302.97 284.07 303 335.66 346.25 309.89",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "173.16 309.89 216.42 335.68 216.42 284.07 173.16 309.89",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "259.69 309.86 216.43 284.07 216.42 284.07 216.42 335.68 216.43 335.68 259.69 309.86",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "259.69 309.86 302.97 335.68 303 335.66 302.97 284.07 302.97 284.07 259.69 309.86",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "259.69 258.24 216.43 284.07 259.69 309.86 259.69 258.24",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "302.97 284.07 259.69 258.24 259.69 309.86 302.97 284.07",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "432.81 464.77 432.89 464.81 432.89 464.72 432.81 464.77",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "86.63 516.32 129.85 490.53 86.63 464.77 86.63 516.32",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "389.59 490.52 389.59 542.13 432.91 516.32 389.61 490.51 389.59 490.52",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "129.86 490.54 129.86 542.15 129.86 542.15 173.14 516.34 129.86 490.54",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "43.36 438.98 43.36 490.57 86.62 464.76 43.36 438.98 43.36 438.98",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "346.52 516.19 346.52 516.46 389.59 542.13 389.59 542.13 389.59 490.52 346.52 516.19",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "432.81 464.77 389.61 490.51 432.91 516.32 432.91 516.32 432.89 464.81 432.81 464.77",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "476.06 438.99 476.09 490.59 432.89 464.81 432.91 516.32 519.36 464.8 476.08 438.98 476.06 438.99",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "173.16 567.93 216.41 542.13 173.16 516.35 173.16 567.93",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "432.89 464.81 476.09 490.59 476.06 438.99 432.89 464.72 432.89 464.81",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "346.56 567.78 303.12 542.05 303.1 542.06 303.12 593.66 389.59 542.13 346.52 516.46 346.56 567.78",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "259.69 567.94 259.69 619.55 303.12 593.66 259.7 567.93 259.69 567.94",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "346.52 516.46 346.52 516.19 346.29 516.32 346.52 516.46",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "259.69 567.93 259.69 567.94 259.7 567.93 303.12 593.66 303.12 593.66 303.1 542.06 259.69 567.93",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "216.43 593.76 259.69 619.55 259.69 567.94 216.43 593.76",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "129.85 490.53 86.63 516.32 86.63 464.77 86.62 464.76 43.36 490.57 43.36 438.98 .1 464.8 129.86 542.15 129.86 490.54 129.85 490.53",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "216.41 542.13 173.16 567.93 173.16 516.35 173.14 516.34 129.86 542.15 216.43 593.76 216.42 542.14 216.41 542.13",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "259.69 567.93 216.42 542.14 216.43 593.76 216.43 593.76 259.69 567.94 259.69 567.93",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "303.12 542.05 346.56 567.78 346.52 516.46 346.29 516.32 303.12 542.05",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "259.69 516.32 303.1 542.03 303.07 490.56 303 490.51 259.69 516.32",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "303.1 542.06 303.12 542.05 303.1 542.03 303.1 542.06",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "303.07 490.56 303.1 542.03 303.12 542.05 346.29 516.32 303.07 490.56",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "216.42 490.52 216.41 490.52 173.16 516.32 173.16 516.35 216.41 542.13 216.42 542.13 216.42 490.52",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "303.07 490.56 303.07 490.46 303 490.51 303.07 490.56",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "389.59 490.49 389.61 490.51 432.81 464.77 389.58 438.97 389.59 490.49",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "432.86 413.19 432.8 413.15 389.58 438.91 389.58 438.97 432.81 464.77 432.89 464.72 432.86 413.19",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "129.86 438.95 86.63 464.76 86.63 464.77 129.85 490.53 129.86 490.53 129.86 438.95",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "389.59 490.52 389.61 490.51 389.59 490.49 389.59 490.52",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "346.48 464.81 346.52 516.19 389.59 490.52 389.59 490.49 346.48 464.81",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "86.62 464.76 86.63 464.77 86.63 464.76 86.62 464.76",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "173.14 516.34 173.16 516.35 173.16 516.32 173.14 516.34",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "129.85 490.53 129.86 490.54 129.86 490.53 129.85 490.53",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "173.16 464.73 173.13 464.72 129.86 490.53 129.86 490.54 173.14 516.34 173.16 516.32 173.16 464.73",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "216.42 542.13 259.69 516.32 216.42 490.52 216.42 542.13",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "129.86 438.95 129.86 490.53 173.13 464.72 129.89 438.94 129.86 438.95",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "216.42 542.13 216.42 542.14 259.69 567.93 259.69 516.32 216.42 542.13",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "259.69 516.32 259.69 567.93 303.1 542.06 303.1 542.03 259.69 516.32",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "432.89 464.72 476.06 438.99 476.06 438.97 432.86 413.19 432.89 464.72",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "173.16 516.32 216.41 490.52 173.16 464.73 173.16 516.32",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "129.86 438.92 129.86 438.95 129.89 438.94 129.86 438.92",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "86.63 413.15 86.63 413.16 86.63 464.76 129.86 438.95 129.86 438.92 86.63 413.15",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "346.48 464.6 346.48 464.81 389.59 490.49 389.58 438.97 389.53 438.94 346.48 464.6",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "216.41 542.13 216.42 542.14 216.42 542.13 216.41 542.13",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "346.31 464.7 303.07 490.46 303.07 490.56 346.29 516.32 346.52 516.19 346.48 464.81 346.31 464.7",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "346.31 464.7 346.48 464.81 346.48 464.6 346.31 464.7",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "476.08 438.98 476.06 438.97 476.06 438.99 476.08 438.98",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "389.58 438.97 389.58 438.91 389.53 438.94 389.58 438.97",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "86.63 413.16 43.36 438.98 86.62 464.76 86.63 464.76 86.63 413.16",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "173.16 413.12 173.15 413.12 129.89 438.94 173.13 464.72 173.16 464.7 173.16 413.12",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "216.42 490.51 216.42 490.52 259.69 516.32 259.69 464.7 216.42 490.51",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "303 438.89 259.69 464.7 259.69 516.32 303 490.51 259.7 464.7 303 490.51 303.07 490.46 303.05 438.92 303 438.89",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "389.53 438.94 346.44 413.23 346.48 464.6 389.53 438.94",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "303.07 490.46 346.31 464.7 303.05 438.92 303.07 490.46",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "216.42 438.91 216.41 438.9 173.16 464.7 173.16 464.73 216.41 490.52 216.42 490.51 216.42 438.91",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "346.44 413.23 346.25 413.12 303.05 438.86 303.05 438.92 346.31 464.7 346.48 464.6 346.44 413.23",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "129.86 387.35 129.86 438.92 129.89 438.94 173.15 413.12 129.89 387.33 129.86 387.35",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "173.13 464.72 173.16 464.73 173.16 464.7 173.13 464.72",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "216.41 490.52 216.42 490.52 216.42 490.51 216.41 490.52",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "216.42 490.51 259.69 464.7 216.42 438.91 216.42 490.51",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "303.05 438.92 303.05 438.86 303 438.89 303.05 438.92",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "389.52 387.33 346.44 413 346.44 413.23 389.53 438.94 389.58 438.91 389.57 387.36 389.52 387.33",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "346.44 413.23 346.44 413 346.25 413.12 346.44 413.23",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "389.58 438.91 432.8 413.15 389.57 387.36 389.58 438.91",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "86.63 413.15 129.86 438.92 129.86 387.35 86.63 413.15",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "173.16 464.7 216.41 438.9 173.16 413.12 173.16 464.7",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "303.05 438.86 346.25 413.12 303.02 387.32 303.05 438.86",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "173.16 361.51 173.16 361.51 173.16 413.11 216.42 387.29 216.42 387.29 173.16 361.51",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "216.42 438.9 216.42 438.91 259.69 464.7 259.69 413.09 216.42 438.9",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "173.16 361.51 129.89 387.33 173.15 413.12 173.16 413.11 173.16 361.51",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "346.44 413 389.52 387.33 346.41 361.6 346.44 413",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "216.42 387.29 216.42 438.9 259.69 413.09 216.42 387.29 216.42 387.29",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "346.25 361.51 303.02 387.26 303.02 387.32 346.25 413.12 346.44 413 346.41 361.6 346.25 361.51",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "302.97 387.29 259.69 413.09 259.69 464.7 303 438.89 259.7 413.09 303 438.89 303.05 438.86 303.02 387.32 302.97 387.29",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "216.41 438.9 216.42 438.91 216.42 438.9 216.41 438.9",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "303.02 387.32 303.02 387.26 302.97 387.29 303.02 387.32",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "173.15 413.12 173.16 413.12 173.16 413.11 173.15 413.12",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "216.42 387.29 173.16 413.11 173.16 413.12 216.41 438.9 216.42 438.9 216.42 387.29",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "303.02 387.26 346.25 361.51 303 335.7 303.02 387.26",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "302.97 335.68 259.69 361.47 259.69 413.09 302.97 387.29 259.7 361.47 302.97 387.29 303.02 387.26 303 335.7 302.97 335.68",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "173.16 361.51 216.42 387.29 216.42 335.68 173.16 361.51",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "216.42 387.29 259.69 413.09 259.69 361.47 216.42 387.29",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "216.42 335.68 216.42 387.29 216.42 387.29 259.69 361.47 216.43 335.68 216.42 335.68",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "216.43 335.68 259.69 361.47 259.69 309.86 216.43 335.68",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "259.69 361.47 302.97 335.68 259.69 309.86 259.69 361.47",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M476.17,180.86l-.12,.06-43.16,25.75h-.06l.06,51.56v51.68l.06,51.56v51.74l-.12-.06-43.16,25.75v.12l-.12-.06-43.04,25.63v.18l-.18-.06-43.22,25.75v.12l-.12-.06-43.28,25.81v103.31l43.47-25.87v-.06l43.4-25.87,43.1-25.63,43.34-25.87,43.16-25.69,43.28-25.81V155.05l-43.28,25.81Zm-129.85,335.55l.18-.12v.18l-.18-.06Zm86.57-51.56l.12-.06v.12l-.12-.06Zm43.22-129.12v-.06l.06,.06h-.06Zm0-51.62v-.06l.06,.06h-.06Zm0-51.56v-.12l.06,.06-.06,.06Z",
    style: {
      fill: "#edeeef"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.38,309.92l-.06-.06,.06-.06-.06-51.56-43.28,25.81h-.06l-43.28,25.81v103.25l43.28-25.81h.06l43.22-25.81,.18-.06-.06-51.5Zm-43.41,25.75h.06v.06l-.06-.06Z",
    style: {
      fill: "#eb0a1e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.95,361.48l-.06-51.56v-51.68l-.06-51.56v-.06l-43.22-25.81-.12-.06-43.22-25.75v-.06h-.06l-43.22-25.81h-.06l-43.22-25.81v103.25l43.28,25.81,43.34,25.87,.06,51.56v.12l.06,51.5v.18l43.1,25.75,.12-.06v.12l43.16,25.75,.12-.06v-51.56h-.12l.12-.06Zm-86.75-154.93l.12-.06v.12l-.12-.06Zm43.4,129.18l.06-.06v.06h-.06Z",
    style: {
      fill: "#edeeef"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "302.98 232.36 259.7 206.55 216.41 232.36 173.13 258.23 216.35 284.05 216.41 284.05 259.7 309.86 302.98 284.05 303.04 284.05 346.32 258.23 302.98 232.36",
    style: {
      fill: "#fa4d56"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "216.41 284.05 216.35 284.05 173.13 258.23 173.13 309.86 173.13 361.48 173.13 361.54 216.41 387.29 259.7 413.1 259.7 361.48 259.7 309.86 216.41 284.05",
    style: {
      fill: "#c40818"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "389.67 387.41 389.54 387.35 346.44 361.6 346.26 361.48 303.04 387.29 303.04 387.35 302.98 387.29 259.7 413.1 216.41 387.29 173.13 361.54 129.85 387.35 129.79 387.41 86.63 413.16 129.79 438.91 129.85 438.97 173.13 464.72 216.41 490.54 259.7 516.35 302.98 490.54 303.1 490.47 346.32 464.72 346.51 464.6 389.54 438.97 389.67 438.91 432.83 413.16 389.67 387.41",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "259.64 103.31 259.51 103.37 216.41 129.12 216.41 129.18 173.19 154.93 173.13 154.93 173.13 154.99 129.91 180.74 129.79 180.86 86.57 206.61 86.57 206.67 86.57 258.23 86.57 258.3 86.57 309.86 86.57 309.92 86.57 361.54 86.57 413.16 86.63 413.16 129.79 387.41 129.79 387.29 129.85 387.35 173.13 361.54 173.13 361.48 173.13 309.86 173.13 258.23 216.41 232.36 259.7 206.55 259.7 154.93 259.7 103.31 259.64 103.31",
    style: {
      fill: "#edeeef"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.05,129.12l-43.28-25.81-43.16-25.75-.06-.06-43.34-25.81-43.34-25.93L259.7,0l-43.28,25.87-43.28,25.81-43.34,25.87-43.16,25.75-.06,.06-43.16,25.75-.12,.12L0,155.05l43.28,25.81,43.28,25.75,43.22-25.75v-.18l.12,.06,43.22-25.75v-.06h.06l43.22-25.75v-.06l43.1-25.75,.12-.06h.06l43.22,25.81h.06l43.22,25.81h.06v.06l43.22,25.75,.12-.06v.12l43.22,25.81,.06,.06,43.16-25.75v-.12l.12,.06,43.28-25.81-43.41-25.93Zm-389.48,25.87v-.12l.12,.06-.12,.06Zm43.22-25.81v-.12l.06,.06-.06,.06Zm43.28-25.81l.06-.06v.06h-.06Zm129.79-25.87v-.12l.12,.06-.12,.06Zm86.63,51.62l.12-.06v.12l-.12-.06Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "216.41 490.54 173.13 464.72 129.85 438.97 129.79 438.97 129.79 438.91 86.63 413.16 86.57 413.16 86.57 361.54 86.57 309.92 86.57 309.86 86.57 258.3 86.57 258.23 86.57 206.67 86.57 206.61 43.28 180.86 0 155.05 0 206.67 0 258.3 0 309.92 0 361.54 0 413.22 0 464.85 43.28 490.66 86.51 516.41 129.79 542.22 173.13 568.03 216.41 593.84 259.7 619.65 259.7 568.03 259.7 516.35 216.41 490.54",
    style: {
      fill: "#dbdcde"
    }
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCubeLogo);
export default __webpack_public_path__ + "static/media/CubeLogo.6e9385b82d25e666c36d888eb5f7cf99.svg";
export { ForwardRef as ReactComponent };